import React, { useEffect, useState } from "react";
import { FileText, Loader2, Cloud, Trash2 } from "lucide-react";
import { toast } from "sonner";
import { api, API, formatApiError } from "../../lib/api";
import UploadZone from "../UploadZone";
import PhotoAnnotator from "../PhotoAnnotator";
import { usePhotoActions } from "../PhotoActions";

const srcOf = (f) => {
  const t = localStorage.getItem("access_token");
  const tp = t ? `?auth=${encodeURIComponent(t)}` : "";
  return `${API}/files/${f.id}/download${tp}${tp ? "&" : "?"}v=${f.size || 0}`;
};

export const PraticaFiles = ({ pid, canEdit }) => {
  const [files, setFiles] = useState(null);
  const [annotating, setAnnotating] = useState(null);
  useEffect(() => { api.get(`/pratiche-allaccio/${pid}/files`).then(({ data }) => setFiles(data || [])).catch(() => setFiles([])); }, [pid]);

  const upload = async (fs) => {
    for (const f of fs) {
      const fd = new FormData(); fd.append("file", f);
      try { const { data } = await api.post(`/pratiche-allaccio/${pid}/files`, fd); setFiles((p) => [...p, data]); }
      catch (err) { toast.error(`${f.name}: ${formatApiError(err)}`); }
    }
    toast.success("Documenti caricati · sincronizzazione Aruba Drive in corso");
  };
  const remove = async (f) => {
    if (!window.confirm(`Eliminare ${f.original_filename}?`)) return;
    try { await api.delete(`/files/${f.id}`); setFiles((p) => p.filter((x) => x.id !== f.id)); toast.success("File eliminato"); }
    catch (err) { toast.error(formatApiError(err)); }
  };
  const images = (files || []).filter((f) => (f.content_type || "").startsWith("image/"));
  const photos = usePhotoActions({ items: images.map((f) => ({ f, src: srcOf(f) })), canEdit, onEdit: setAnnotating, onDelete: remove });

  if (files === null) return <Loader2 className="w-4 h-4 animate-spin" />;
  return (
    <div className="space-y-2" data-testid={`pratica-files-${pid}`}>
      {canEdit && <UploadZone onFiles={upload} />}
      {files.length === 0 ? <div className="text-xs" style={{ color: "var(--text-muted)" }}>Nessun documento.</div> : (
        <div className="grid grid-cols-3 md:grid-cols-6 gap-2">
          {files.map((f) => {
            const img = (f.content_type || "").startsWith("image/");
            return (
              <div key={f.id} className="relative rounded-lg border overflow-hidden bg-white" style={{ borderColor: "var(--border)" }} data-testid={`pratica-file-${f.id}`}>
                {img ? <button type="button" onClick={() => photos.open(f.id)} className="block w-full" data-testid={`pratica-photo-thumb-${f.id}`}><img src={srcOf(f)} alt={f.original_filename} className="w-full h-20 object-cover" loading="lazy" /></button>
                  : <a href={srcOf(f)} target="_blank" rel="noreferrer" className="flex flex-col items-center justify-center h-20 gap-1" style={{ background: "var(--surface-muted)" }} data-testid={`pratica-doc-${f.id}`}><FileText className="w-6 h-6" style={{ color: "var(--primary)" }} /><span className="text-[10px] uppercase">PDF</span></a>}
                <div className="p-1 text-[10px] truncate flex items-center gap-1">{f.nextcloud_path && <Cloud className="w-3 h-3 shrink-0" style={{ color: "#10B981" }} />}<span className="truncate">{f.original_filename}</span></div>
                {canEdit && !img && <button onClick={() => remove(f)} className="absolute top-1 right-1 p-1 rounded bg-black/70 text-white" data-testid={`pratica-file-delete-${f.id}`}><Trash2 className="w-3 h-3" /></button>}
              </div>
            );
          })}
        </div>
      )}
      {photos.ui}
      {annotating && <PhotoAnnotator fileId={annotating.id} fileName={annotating.original_filename} onClose={() => setAnnotating(null)} onSaved={(doc) => setFiles((p) => p.map((x) => (x.id === doc.id ? doc : x)))} />}
    </div>
  );
};
